import React from 'react';
import './title.css';
const Title = () => (
  <div className="title__header section__margin">
    <div className="title-content">
      <h1>TimeBar</h1>
    </div>
  </div>
)

export default Title
